/* =========================
 * 베스트 쿠폰 추천 모듈
 * ========================= */

/**
 * 숫자 변환 (NaN → 기본값)
 */
function toNumber(v, def = 0) {
  const n = Number(v);
  return Number.isFinite(n) ? n : def;
}

/**
 * 날짜를 일 단위로 절삭
 */
function truncateDate(d) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

/**
 * 기준 날짜가 [from, until] 안에 포함되는지 확인
 */
function isWithinDateRange(from, until, ref = new Date()) {
  const refTime = truncateDate(ref).getTime();
  const startOk = !from || truncateDate(new Date(from)).getTime() <= refTime;
  const endOk   = !until || truncateDate(new Date(until)).getTime() >= refTime;
  return startOk && endOk;
}

/**
 * 장바구니 합계 계산
 * @param {Object|number} cart - 장바구니 객체 또는 금액
 * @param {Object} options - 옵션
 * @param {string[]} options.applicableCollectionIds - 적용 가능한 콜렉션 ID 목록 (쿠폰 필터링용)
 */
function computeSubtotal(cart, { units = 'major', minorFactor = 100, applicableCollectionIds = null } = {}) {
  if (typeof cart === 'number') return Math.max(0, cart);
  if (!cart) return 0;

  // ✅ 콜렉션 필터링이 없으면 기존 로직 사용
  if (!applicableCollectionIds || applicableCollectionIds.length === 0) {
    if (cart.subtotal != null) return Math.max(0, cart.subtotal);

    if (Array.isArray(cart.lineItems)) {
      return cart.lineItems.reduce((s, li) =>
        s + toNumber(li.price) * toNumber(li.quantity, 1), 0);
    }

    if (Array.isArray(cart.items)) {
      // ✅ 할인 전 원가 기준으로 계산
      const raw = cart.items.reduce((s, it) => {
        const originalPrice = it.original_line_price != null
          ? toNumber(it.original_line_price)
          : (it.line_price != null
            ? toNumber(it.line_price)
            : toNumber(it.price) * toNumber(it.quantity, 1));
        return s + originalPrice;
      }, 0);
      return units === 'minor' ? Math.floor(raw / minorFactor) : raw;
    }

    return 0;
  }

  // ✅ 콜렉션 필터링 적용: DOM에서 collection IDs 읽어서 필터링
  if (Array.isArray(cart.items)) {
    const eligibleItems = cart.items.filter((item, index) => {
      // DOM에서 해당 아이템의 콜렉션 정보 읽기
      const cartItemElement = document.querySelectorAll('[data-collection-ids]')[index];
      if (!cartItemElement) return false;

      const collectionIds = cartItemElement.getAttribute('data-collection-ids');
      if (!collectionIds) return false;

      const itemCollections = collectionIds.split(',').map(id => id.trim());

      // 적용 가능한 콜렉션 중 하나라도 포함되어 있으면 true
      return applicableCollectionIds.some(applicableId =>
        itemCollections.includes(String(applicableId))
      );
    });

    // ✅ 할인 전 원가 기준으로 계산 (original_line_price 또는 line_price 사용)
    const raw = eligibleItems.reduce((s, it) => {
      const originalPrice = it.original_line_price != null
        ? toNumber(it.original_line_price)
        : (it.line_price != null
          ? toNumber(it.line_price)
          : toNumber(it.price) * toNumber(it.quantity, 1));
      return s + originalPrice;
    }, 0);

    return units === 'minor' ? Math.floor(raw / minorFactor) : raw;
  }

  return 0;
}

/**
 * 쿠폰 유효성 체크
 */
function isCouponValid(c, subtotal, ref = new Date()) {
  if (!c || c.is_used || !c.is_active) return false;
  if (!isWithinDateRange(c.valid_from, c.valid_until, ref)) return false;
  if (c.minimum_amount && subtotal < toNumber(c.minimum_amount)) return false;
  return true;
}

/**
 * 쿠폰 절감액 계산 (max cap 반영)
 * @param {number} subtotal - 적용 가능한 상품의 합계 금액
 * @param {Object} c - 쿠폰 객체
 */
function calcSavings(subtotal, c) {
  let save = 0;

  if (c.coupon_type === 'percentage') {
    save = (subtotal * toNumber(c.discount_value)) / 100;
  }
  if (c.coupon_type === 'fixed_amount') {
    save = toNumber(c.discount_value);
  }

  if (c.maximum_discount) {
    save = Math.min(save, toNumber(c.maximum_discount));
  }

  save = Math.min(save, subtotal); // 초과 방지
  return Math.floor(Math.max(0, save));
}

/**
 * 최적 쿠폰 추천
 * @return {Object|null} { index, code, savings } or null
 */
function recommendBestCoupon(cart, coupons, ref = new Date(), opts) {
  // ✅ 모든 쿠폰은 콜렉션 288565690507에 속하는 제품에만 적용 (고정값)
  const FIXED_APPLICABLE_COLLECTION_IDS = ['288565690507'];

  const candidates = coupons
    .map((c, i) => {
      // ✅ 고정 콜렉션 ID로 subtotal 계산
      const subtotal = computeSubtotal(cart, {
        ...opts,
        applicableCollectionIds: FIXED_APPLICABLE_COLLECTION_IDS
      });

      const valid = isCouponValid(c, subtotal, ref);
      const savings = valid ? calcSavings(subtotal, c) : 0;

      return {
        index: i,
        code: c.coupon_code,
        savings,
        valid,
        applicableCollectionIds: FIXED_APPLICABLE_COLLECTION_IDS,
        subtotal
      };
    })
    .filter(e => e.valid && e.savings > 0);

  if (!candidates.length) return null;

  console.log('[쿠폰별 할인 금액]', candidates)

  candidates.sort((a, b) => b.savings - a.savings);
  const { index, code, savings } = candidates[0];
  return { index, code, savings };
}
